import React, { useState, useEffect } from 'react';
import { Menu, X, ChevronRight } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    setIsMobileMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    } else if (id === 'accueil') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const navItems = [
    { label: 'Accueil', id: 'accueil' },
    { label: 'Services TI', id: 'services' },
    { label: 'Téléphonie', id: 'telephonie' },
    { label: 'Sur Mesure', id: 'logiciels-sur-mesure' },
    { label: 'Nos Produits', id: 'produits' },
    { label: 'Contact', id: 'contact' }
  ];

  return (
    <>
      <header 
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled 
            ? 'glass shadow-[0_8px_32px_rgba(0,0,0,0.5)]' 
            : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex items-center justify-between h-20">
            
            {/* Logo */}
            <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('accueil')}>
              <img 
                src="/innova-logo.png" 
                alt="Innova-Solution" 
                className="h-12 md:h-14 w-auto object-contain"
              />
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center gap-8">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="text-sm text-gray-300 hover:text-[#FF6B35] transition-colors font-medium uppercase tracking-wider"
                >
                  {item.label}
                </button>
              ))}
              <a href="/supportit" className="text-sm text-gray-300 hover:text-[#FF6B35] transition-colors font-medium uppercase tracking-wider">
                Support IT
              </a>
              <a href="/admin" className="text-sm text-gray-400 hover:text-[#FF6B35] transition-colors font-medium uppercase tracking-wider">
                Admin
              </a>
              <Button 
                onClick={() => scrollToSection('contact')}
                className="bg-[#FF6B35] text-white font-semibold rounded-md px-6 py-3 hover:bg-[#FF8555] transition-all hover:shadow-[0_0_20px_rgba(255,107,53,0.4)]"
              >
                Demander une soumission
                <ChevronRight className="ml-2 w-4 h-4" />
              </Button>
            </nav>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden p-2 text-white hover:text-[#FF6B35] transition-colors"
              aria-label="Toggle menu"
            >
              {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>

          {/* Mobile Navigation */}
          {isMobileMenuOpen && (
            <nav className="lg:hidden pb-6 space-y-3 animate-in slide-in-from-top duration-200">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="block w-full text-left px-4 py-3 text-gray-300 hover:bg-white/5 hover:text-[#FF6B35] rounded-lg transition-colors uppercase tracking-wide text-sm"
                >
                  {item.label}
                </button>
              ))}
              <a 
                href="/supportit" 
                className="block w-full text-left px-4 py-3 text-gray-300 hover:bg-white/5 hover:text-[#FF6B35] rounded-lg transition-colors uppercase tracking-wide text-sm"
              >
                Support IT
              </a>
              <a 
                href="/admin" 
                className="block w-full text-left px-4 py-3 text-gray-400 hover:bg-white/5 hover:text-[#FF6B35] rounded-lg transition-colors uppercase tracking-wide text-sm"
              >
                Admin
              </a>
              <Button 
                onClick={() => scrollToSection('contact')}
                className="w-full bg-[#FF6B35] hover:bg-[#FF8555] text-white mt-2 py-3"
              >
                Demander une soumission
              </Button>
            </nav>
          )}
        </div>
      </header>
    </>
  );
};
